import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import caldeoFilters
  from '@lba-dev/package.local-globals/Filters/InterFilters/caldeoFilters';
import {
  getSubStatuses,
} from '@lba-dev/package.local-globals/caldeoType';

import { List as listData } from '../../../utils/List/ListeAides';
import { callBackFunction } from '../../Utils/ListFunctions';
import collections from '../../../constants/collections';
import ListLogic from '../ListLogic';
import InterActions from '../Intervention/InterActions';
import InterMenu from '../Intervention/InterMenu';

const functionType = [
  {
    type: 'categorie',
    callback: callBackFunction.categorie,
  },
];

const getTabFilter = (baseFilter, params, tab) => {
  if (!tab || !params?.filter) {
    return baseFilter;
  }
  const currentFilter = caldeoFilters()[params.filter];
  if (!currentFilter?.mainStatusId) {
    return baseFilter;
  }
  const subStatuses = getSubStatuses(currentFilter.mainStatusId);
  const subStatus = subStatuses[tab - 1];
  if (!subStatus) {
    return baseFilter;
  }
  return {
    ...baseFilter,
    $or: [
      { 'caldeo.mainStatus': { $in: [subStatus._id] } },
      { 'caldeo.subStatus': { $in: [subStatus._id] } },
    ],
  };
};

const AidesList = (props) => {
  const {
    name = 'interventions',
    listen = collections.interventions,
    handlerFilterByColumns,
    filteredByColumn = true,
    sort,
    filterName,
    count,
    filter: filterProps,
    tab,
    params,
    list
  } = props;

  const [baseFilter, setBaseFilter] = useState(filterProps);
  const [display] = useState(count || 25);
  const users = useSelector(({ users }) => users);
  const newListData = (list || listData({ users }).default.dataFormat);

  useEffect(() => {
    setBaseFilter(filterProps);
  }, [filterProps]);

  const filter = useMemo(
    () => getTabFilter(baseFilter, params, tab),
    [baseFilter, params, tab]
  );

  if (filterName !== 'default' && Object.keys(baseFilter).length === 0) {
    return null;
  }
  return (
    <React.Fragment>
      <ListLogic
        {...newListData}
        handlerFilterByColumns={handlerFilterByColumns}
        project={[]}
        functionType={functionType}
        filteredByColumn={filteredByColumn}
        name={name}
        actions={InterActions}
        menu={InterMenu}
        collection={listen}
        listen={listen}
        filter={filter}
        count={display}
        sort={sort}
      />
    </React.Fragment>
  );
};

export default AidesList;
